// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "98b84bc2add5b17656d5" + ".js";
};